/**
 * SacEvent
 * @author JoodyKonno
 */

export enum SacEvent {
  CREATED = 'Emissão nota fiscal',
  SHIPPING = 'Aguardando Rota de Entrega',
  SCHEDULED = 'Em Rota de Entrega',
  STARTED = 'Em trânsito, a caminho do cliente',
  SHIPPED = 'Chegada no endereço',
  SUCCESS = 'Entregue ao destinatário com sucesso',
}
